import React from 'react';
import TextboxField from '../../../components/Fields/TextboxField';
import SelectListField from '../../../components/Fields/SelectListField';
import { FieldProps } from '../../../components/Fields/Types';
import Title from '../../../components/Headers/Title';
import useSelectListOptions from '../../../components/Hooks/SelectListOptionsHook/useSelectListOptions';

interface BusinessPartnerControlProps {
    getFieldProps: (string) => FieldProps
}

const BusinessPartnerControl: React.FC<BusinessPartnerControlProps> = ({ getFieldProps }) => {
    const businessPartnerTypes = useSelectListOptions('api/v1/selectlist/BusinessPartnerTypes', '-- Select business-partner type');

    return (
        <>
            <Title text={'Contactperson'} size={5} />
            <SelectListField {...getFieldProps('businessPartnerUser.businessPartner.businessPartnerTypeId')} options={businessPartnerTypes} disabled />
            <TextboxField {...getFieldProps('businessPartnerUser.businessPartner.name')} disabled />
            <TextboxField {...getFieldProps('businessPartnerUser.contactperson')} disabled />

        </>
    );
}
export default BusinessPartnerControl;